
import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { merge, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { SegnalazioniService } from 'src/app/services/eventi-segnalazioni.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { GestioneSegnalazioniDataSource } from 'src/app/services/gestione-segnalazioni.datasource';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { TipoDocumento } from 'src/app/model/TipoDocumento.enum';
import { environment } from 'src/environments/environment';
import { InvioSegnalazioniService } from 'src/app/services/invio-segnalalazioni.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-gestione-invio-segnalazioni',
  templateUrl: './gestione-invio-segnalazioni.component.html',
  styleUrls: ['./gestione-invio-segnalazioni.component.css'],
  providers: [DatePipe]
})
export class GestioneInvioSegnalazioniComponent implements OnInit {


  arrowFlag: boolean = false;
  risultatiPerPagina: number = 10;
  dataSource: GestioneSegnalazioniDataSource;
  acl: string = '';

  segnalazioniSearchableDto: ModelEventiCalamitosi.SegnalazioneDaInviareDTO = {
    idInvio: null,
    dpgr: null,
    dataEventoDa: null,
    dataEventoA: null,
    descrizione: null,
    dataCreazione: null,
    idEvento: null,
    idEnte: null,
    utenteGenerazione: null,
    numSegnalazioni: null,
    dataMaxDocumento: null,
    dataInvio: null,
    stato: null,
    fileCaricato: null,
    numProtoEnteAt: null,
    dataProtoEnteAt: null,
    numProtoRve: null,
    dataProtoRve: null
  };

  public form: FormGroup;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;

  /**
   *
   *
   * @type {EventEmitter<ToolbarEvent>}
   * @memberof DataTableComponent
   */
  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  public toolbar: Toolbar;

  /**
  *
  * Filtri di ricerca impostati dall'utente
  * @type {ModelEventiCalamitosi.SegnalazioniSearchableDTO}
  */
  public searchFilters: ModelEventiCalamitosi.SegnalazioneDaInviareDTO;
  openToggle: number = 0;
  emptyTableMessage: boolean;
  idTemplate: any;
  dataChiusuraRaccoltaDati: any;
  dataChiusuraCorrezioneDati: any;

  private buildForm(): void {
    let group = {
      idInvio: new FormControl(null, null),
      dpgr: new FormControl(null, null),
      dataEventoDa: new FormControl(null, null),
      dataEventoA: new FormControl(null, null),
      dataCreazione: new FormControl(null, null),
      stato: new FormControl(null, null),
      fileCaricato: new FormControl(null, null),
      numProtoEnteAt: new FormControl(null, null),
      dataProtoEnteAt: new FormControl(null, null),
      numProtoRve: new FormControl(null, null),
      dataProtoRve: new FormControl(null, null),
    }
    this.form = new FormGroup(group);
  }


  displayedColumns: string[] = ['idInvio', 'dpgr', 'dataEvento', 'dataCreazione', 'stato', 'fileCaricato',
    'numProtoEnteAt', 'dataProtoEnteAt', 'numProtoRve', 'dataProtoRve', 'actions'];
   private intervalId: any;


  constructor(
    private segnalazioniSvc: SegnalazioniService,
    private router: Router,
    private alertsCenterService: AlertsCenterService,
    private http: HttpClient,
    private invioSegnalazioniSvc: InvioSegnalazioniService,
    private datePipe: DatePipe,
    // private authenticationService: AuthenticationService,
    private dialogService: DialogService) {
    this.generateToolBar();

  }

  ngOnInit(): void {
    this.buildForm();
    this.dataSource = new GestioneSegnalazioniDataSource(this.segnalazioniSvc);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })

    this.acl = sessionStorage.getItem("acl");

     this.callApi();

        // Esegui ogni 5 minuti (300000 ms)
        this.intervalId = setInterval(() => {
          this.callApi();
        }, 300000);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sort.direction = "desc";
      this.sort.active = "dataCreazione";
      this.dataSource.loadSegnalazioniDaInviare('', this.segnalazioniSearchableDto, 'dataCreazione,'+ this.sort.direction, 0, this.risultatiPerPagina, 1);

      // reset the paginator after sorting
      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaSegnalazioni();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  public ricercaListaSegnalazioni(resetPage?: boolean): void {

    const dataCreazioneValue = this.getFormValueOrNull('dataCreazione');
    const dataProtoEnteAtValue = this.getFormValueOrNull('dataProtoEnteAt');
    const dataProtoRveValue = this.getFormValueOrNull('dataProtoRve');
    const dpgrValue = this.getFormValueOrNull('dpgr');
    const dataEventoDaValue = this.getFormValueOrNull('dataEventoDa');
    const dataEventoAValue = this.getFormValueOrNull('dataEventoA');

    if (dataEventoAValue !== null && dataEventoDaValue !== null && dataEventoDaValue > dataEventoAValue) {
      let message = "Data di inizio maggiore della data di fine";
      this.alertsCenterService.showAlert({
        message: message,
        type: 'danger',
        autoClosable: false
      });
      return;
    }

    this.searchFilters = {
      idInvio: this.getFormValueOrNull('idInvio'),
      dpgr: dpgrValue,
      dataEventoDa: dataEventoDaValue ? this.datePipe.transform(dataEventoDaValue, 'yyyy/MM/dd') : null,
      dataEventoA: dataEventoAValue ? this.datePipe.transform(dataEventoAValue, 'yyyy/MM/dd') : null,
      dataCreazione: dataCreazioneValue ? this.datePipe.transform(dataCreazioneValue, 'yyyy/MM/dd') : null,
      stato: this.getFormValueOrNull('stato'),
      fileCaricato: this.getFormValueOrNull('fileCaricato'),
      numProtoEnteAt: this.getFormValueOrNull('numProtoEnteAt'),
      dataProtoEnteAt: dataProtoEnteAtValue ? this.datePipe.transform(dataProtoEnteAtValue, 'yyyy/MM/dd') : null,
      numProtoRve: this.getFormValueOrNull('numProtoRve'),
      dataProtoRve: dataProtoRveValue ? this.datePipe.transform(dataProtoRveValue, 'yyyy/MM/dd') : null,
      descrizione: null,
      idEvento: null,
      idEnte: null,
      utenteGenerazione: null,
      numSegnalazioni: null,
      dataMaxDocumento: null,
      dataInvio: null,
    }

    this.dataSource.loadSegnalazioniDaInviare('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize, 1);
  }

  getFormValueOrNull(field: string): any {
    return this.form.controls[field].value !== "" ? this.form.controls[field].value : null;
  }

  onNavigate(path) {
    this.router.navigate([path])
  }

  downloadSegnalazioni(url) {
        window.location.href = url;
  }

  private callApi(): void {
    this.http.get('/eventicalamitosi/api/proto/getstatus').subscribe({
      next: (response) => console.log('Risposta:', response),
      error: (error) => console.error('Errore:', error),
    });
  }

  private generateToolBar() {
    this.toolbar = {
      toolbarCss: 'toolbar-horizontal',
      actions: [
        {
          btnTitle: 'Dettaglio',
          btnActionEvent: 'show_detail_page',
          btnIconClass: 'description',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Dowload pdf',
          btnActionEvent: 'download_pdf',
          btnIconClass: 'picture_as_pdf',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Dowload excel',
          btnActionEvent: 'download_excel',
          btnIconClass: 'view_compact',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Carica file firmato',
          btnActionEvent: 'show_dialog_upoload_file',
          btnIconClass: 'file_upload',
          btnCssClass: 'btn btn-secondary',
          btnIsToShowButton: (row: any) => {
            return row.stato == null || row.stato == "Attesa Invio";
          }
        },
        {
          btnTitle: 'Download file firmato',
          btnActionEvent: 'show_signet_file',
          btnIconClass: 'download',
          btnCssClass: 'btn btn-secondary',
          btnIsToShowButton: (row: any) => {
            return row.fileCaricato == "SI";
          }
        },
        {
          btnTitle: 'Invia a protocollo regionale',
          btnActionEvent: 'uploadToRegionProtocol',
          btnIconClass: 'send',
          btnCssClass: 'btn btn-secondary',
          btnIsToShowButton: (row: any) => {
            return row.fileCaricato == "SI" && (row.stato == null || row.stato == "Attesa Invio");
          }
        }
      ]
    }
  }

  openDettaglioUploadDialog(descrizione: string, idEvento: number, idEnte: number, idInvio: number) {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    const dialogConfig = new MatDialogConfig();
    // console.log(idEvento, idEnte, idInvio)

    dialogConfig.data = {
      idEvento: idEvento,
      idEnte: idEnte,
      idInvio: idInvio,
      predefiniti: false
    }

    const dialogRef = this.dialogService.openDialogUpload(descrizione, idEvento, idEnte, idInvio).subscribe();
  }

  openDettaglioInviaPortocolloDialog(descrizione: string, idEvento: number, idEnte: number, idInvio: number) {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    const dialogConfig = new MatDialogConfig();
    // console.log(idEvento, idEnte, idInvio)

    dialogConfig.data = {
      idEvento: idEvento,
      idEnte: idEnte,
      idInvio: idInvio,
      predefiniti: false
    }

    const dialogRef = this.dialogService.openInviaProtocolloUpload(descrizione, idEvento, idEnte, idInvio).subscribe();
  }

  openShowDetailPage(idEnte, idInvio: number) {
    this.onNavigate('dettaglio-segnalazione/' + idEnte + '/' + idInvio);
  }

  public ricercaDate(resetPage?: boolean): void {
    // this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, "codiceCampo" + "," + "ASC", this.paginator.pageIndex, this.paginator.pageSize, 'N', this.templateDistribuito, this.allAbilitati);
  }

  // RF05 Massimo fix show or hide toolbar components by stato.
  public handleToolbarEvent(event: ToolbarEvent): void {
    console.log(event);

    const disabilitati = ['show_dialog_upoload_file', 'uploadToRegionProtocol'];
    if ((event.data?.stato === 'Protocollato' || event.data?.stato === 'Inviato' ) && disabilitati.includes(event.event)) {
      this.alertsCenterService.showAlert({
        message: 'Azione non disponibile per una segnalazione protocollata o inviata',
        type: 'danger', // oppure 'danger' se vuoi un tono più severo
        autoClosable: true
      });
      return;
    }

    switch (event.event) {
      case 'show_dialog_upoload_file':
        this.openDettaglioUploadDialog(event.data.descrizione, event.data.idEvento, event.data.idEnte, event.data.idInvio);
        break;
      case 'show_detail_page':
        this.openShowDetailPage(event.data.idEnte, event.data.idInvio);
        break;
      case 'download_pdf':
        this.downloadSegnalazioni(`api/files/download-segnalazioni/${event.data.idInvio}/${event.data.idEvento}/PDF`);
        break;
      case 'download_excel':
        this.downloadSegnalazioni(`api/files/download-segnalazioni/${event.data.idInvio}/${event.data.idEvento}/EXCEL`);
        break;
      case 'show_signet_file':
        this.downloadFile(`api/files/allegato?idallegato=${event.data.idAllegato}`, event.data.nomeFile, 'pdf');
        break;
      case 'uploadToRegionProtocol':
        this.openDettaglioInviaPortocolloDialog(event.data.descrizione, event.data.idEvento, event.data.idEnte, event.data.idInvio);
        break;
    }
  }



  downloadFile(url: string, filename: string, type: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/octet-stream');

    this.http.get(url, { headers: headers, responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      },
      (error) => {
        console.error('Download failed:', error);
      }
    );
  }

  showEnteTab(idEnte) {
    return "Ente prova " + idEnte;
  }

  onReset() {
    this.segnalazioniSearchableDto = {
      idInvio: null,
      dpgr: null,
      dataEventoDa: null,
      dataEventoA: null,
      descrizione: null,
      dataCreazione: null,
      idEvento: null,
      idEnte: null,
      utenteGenerazione: null,
      numSegnalazioni: null,
      dataMaxDocumento: null,
      dataInvio: null,
      stato: null,
      fileCaricato: null,
      numProtoEnteAt: null,
      dataProtoEnteAt: null,
      numProtoRve: null,
      dataProtoRve: null
    };
    this.form.reset();
    this.dataSource.loadSegnalazioniDaInviare('', this.segnalazioniSearchableDto, 'dataCreazione,'+ 'DESC', 0, this.risultatiPerPagina, 1);
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

}
